import {transactionPaymentCategoryBase_template} from "./transactionPaymentCategoryBase_template";

declare var ko: any;
declare var page: any;

export class transactionPerformancePaymentCategory_template extends transactionPaymentCategoryBase_template {

    protected getTemplateName(): string {
        return "transactionPerformancePaymentCategory_template";
    }

    protected getTemplateHtml(): string {
        return `
            <div id="session-brand-target" class="form-body full-width" >
                <div class="form-group row" style="width: 50%;justify-content: flex-start;">
                    <button class="btn icon i-plus" data-bind="text: 'Add ' + system() + ' Payment Category', event: { click: onAddPaymentCategory }" ></button>
                </div>
                <div class="w-list-results">

                    <table class="list-results">
                        <thead>
                            <tr>
                                <th class="border-right"><span></span></th>
                                <th style="text-align:center;" class="border-right border-bottom" colspan="7"><span>Writer</span></th>
                                <th style="text-align:center;" class="border-right border-bottom" colspan="7"><span>Editor</span></th>
                                <th colspan="3"><span></span></th>
                            </tr>
                            <tr class="mini">
                                <th class="border-right"></th>
                                <!-- Writer columns -->
                                <th class="border-right sub-section"></th>
                                <th colspan="3" class="border-right sub-section"><span>Sessions Performance</span></th>
                                <th colspan="3" class="border-right sub-section alt"><span>US Sessions Performance</span></th>
                                <!-- Editor columns -->
                                <th class="border-right sub-section"></th>
                                <th colspan="3" class="border-right sub-section"><span>Sessions Performance</span></th>
                                <th colspan="3" class="border-right sub-section alt"><span>US Sessions Performance</span></th>
                                <!-- Other 3 columns -->
                                <th colspan="3"></th>                                
                            </tr>
                            <tr>
                                <th class="border-right"><span>Payment Category</span></th>
                                <!-- Writer columns -->
                                <th class="border-right"><span>Commission</span></th>
                                <th><span>Rate</span></th>
                                <th><span>Min</span></th>
                                <th class="border-right"><span>Max</span></th>
                                <th><span>Rate</span></th>
                                <th><span>Min</span></th>
                                <th class="border-right"><span>Max</span></th>

                                <!-- Editor columns -->
                                <th class="border-right"><span>Commission</span></th>
                                <th><span>Rate</span></th>
                                <th><span>Min</span></th>
                                <th class="border-right"><span>Max</span></th>
                                <th><span>Rate</span></th>
                                <th><span>Min</span></th>
                                <th class="border-right"><span>Max</span></th>

                                <!-- Other 3 columns -->
                                <th><span>Weight</span></th>
                                <th><span>Range</span></th>
                                <th><span>Status</span></th>
                            </tr>
                        </thead>


                         <tbody data-bind="foreach: paymentCategories">
                            <tr class="brand-row">
                                <td class="border-right">
                                    <!-- ko if: categoryId -->
                                    <h3><span data-bind="text: categoryName"></span></h3>
                                    <!-- /ko -->
                                    <!-- ko ifnot: categoryId -->
                                    <input type="text" style="width: 100%" class="input-text" data-bind="value: categoryName" />
                                    <!-- /ko -->
                                </td>
                                <!-- Writer columns -->
                                <td class="border-right"><input type="number" class="input-text" data-bind="value: writerCommissionAmount"></td>
                                <td><input type="number" class="input-text" data-bind="value: writerSessionAmount"></td>
                                <td><input type="number" class="input-text" data-bind="value: writerSessionMin"></td>
                                <td class="border-right"><input type="number" class="input-text" data-bind="value: writerSessionMax"></td>
                                <td><input type="number" class="input-text" data-bind="value: writerUsSessionAmount"></td>
                                <td><input type="number" class="input-text" data-bind="value: writerUsSessionMin"></td>
                                <td class="border-right"><input type="number" class="input-text" data-bind="value: writerUsSessionMax"></td>
                                
                                <!-- Editor columns -->
                                <td class="border-right"><input type="number" class="input-text" data-bind="value: editorCommissionAmount"></td>
                                <td><input type="number" class="input-text" data-bind="value: editorSessionAmount"></td>
                                <td><input type="number" class="input-text" data-bind="value: editorSessionMin"></td>
                                <td class="border-right"><input type="number" class="input-text" data-bind="value: editorSessionMax"></td>
                                <td><input type="number" class="input-text" data-bind="value: editorUsSessionAmount"></td>
                                <td><input type="number" class="input-text" data-bind="value: editorUsSessionMin"></td>
                                <td class="border-right"><input type="number" class="input-text" data-bind="value: editorUsSessionMax"></td>
                                
                                <!-- Other 3 columns -->
                                <td><input type="number" class="input-text" data-bind="value: categoryWeight"></td>
                                <td><input type="number" class="input-text" data-bind="value: dateRange"></td>
                                <td>
                                    <!-- ko if: categoryId -->
                                    <input type="checkbox" class="input-text" data-bind="checked: isDeleted, attr: {id: 'payment-category-' + categoryId }" />
                                    <label class="form-label icon i-check" data-bind="attr: {for: 'payment-category-' + categoryId }">Is Inactive</label>
                                    <!-- /ko -->

                                    <!-- ko ifnot: categoryId -->
                                    <button class="btn icon i-delete" data-bind="event: { click: onRemovePaymentCategory }, attr: {id: 'payment-category-' + categoryId }"></button>
                                    <!-- /ko -->
                                </td>
                            </tr>
                         </tbody>
                  </table>
               </div>

               <div class="form-footer">
                  <button class="btn" data-bind="event: { click: onClickCancel }, text: 'Cancel'" >Save</button>
                  <button class="btn highlight" data-bind="event: { click: onClickSave }, text: 'Save'" >Save</button>
               </div>
               
            </div>
        `;
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/transactionPerformancePaymentCategory_template.ts